export default "__VITE_ASSET__CBLv6P5k__"